<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('RectangleTool', function() {
            return {
                // Descriptor for the tool
                group: 'Rectangle', category: 'Shapes', icon: this.getIcon('rectangle'),
                name: 'Rectangle',
                type: 'PriceTime',
                hint: 'Price Range',
                data: [],     // Default data
                settings: {}, // Default settings
            }
        }, 'Rectangle')
</script>
